import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideEnvironmentInitializer,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { InitService } from '@infodata-group/inf-commons';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { environment } from '../environments/environment';
import {
  commonsProviders,
  commonsProvidersFrom,
} from './config/commons.config';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideEnvironmentInitializer(() =>
      inject(InitService).init(environment.env),
    ),
    importProvidersFrom(...commonsProvidersFrom),
    provideCharts(withDefaultRegisterables()),
    commonsProviders,
    { provide: LOCALE_ID, useValue: 'fr' },
  ],
};
